import { Box, Container, Grid, Typography } from '@mui/material'
import { useClosestPayments } from '@src/api/payment-api/payment-hoocks'
import { usePayment } from '@src/api/payment-api/payments-api'
import { LastPaymentCard, PageSpinner, PaymentsInfo, TitleSection } from '@src/components'
import { getDaysToNextPayment } from '@src/services/Formatter'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import LastPayments from './components/LastPayments'

const Calendar = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  const [payment, isLoading] = usePayment(id)
  const { closestPayment, closedNextPayment } = payment ?? {}

  const today = new Date().toISOString()
  const [payments, isLoadingClosest] = useClosestPayments(5, id!, today)

  if (isLoading || isLoadingClosest) return <PageSpinner isLoading={true} />

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  const getDisplayDaysToNextPayment = (nextPaymentDateUTC: string): string => {
    const daysDifference = getDaysToNextPayment(nextPaymentDateUTC)
    const daysMessage = daysDifference === 0 ? t('payment.today') : `${daysDifference} ${t('payment.days')}`
    return daysMessage
  }

  const displayDaysToNextPayment = closestPayment ? getDisplayDaysToNextPayment(closestPayment.plannedOnDateUTC) : ''
  const nextPayment = payment?.closestPayment
  const previousPayment = payment?.lastPayment
  const lastFivePayments = payments?.slice(-5) || []

  const renderPaymentsInfo = () => {
    if (!nextPayment) return null

    return (
      <PaymentsInfo
        payments={closestPayment ? [closestPayment] : []}
        closedNextPayment={closedNextPayment}
        daysToNextPayment={displayDaysToNextPayment}
      />
    )
  }

  const renderLastPaymentCard = () => {
    if (!nextPayment) return null

    return <LastPaymentCard selectedPayment={previousPayment} />
  }

  const renderLastPayments = () => {
    if (!lastFivePayments || lastFivePayments.length === 0) return null

    return <LastPayments payments={payments} toggleAccordion={toggleAccordion} activeIndex={activeIndex} />
  }

  const renderPaymentsDescription = () => {
    if (!lastFivePayments || lastFivePayments.length === 0) return null

    return <Typography sx={{ fontWeight: '200', mb: 2 }}>{5} {t('payment.lastTransaction')}</Typography>
  }

  return (
    <>
      <TitleSection title={t('payment.calendarTitle')} />
      <Container component="main" sx={{ flexGrow: 1 }}>
        <Grid container>
          <Grid size={{ xs: 12, md: 9, lg: 11 }}>
            <Box sx={{ padding: { xs: '0 1px', sm: '0 18px' }, boxSizing: 'border-box' }}>
              <Box>
                {renderPaymentsInfo()}
                {renderLastPaymentCard()}
                <Box>
                  {renderPaymentsDescription()}
                  {renderLastPayments()}
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default Calendar
